import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20cherry%20blossom%20landscape%20with%20soft%20pink%20petals%20falling%2C%20warm%20sunset%20golden%20hour%20lighting%2C%20dreamy%20atmosphere%2C%20Japanese%20spring%20scenery%20with%20distant%20mountains%2C%20ethereal%20and%20artistic%20illustration%20style%2C%20soft%20focus%20background%20with%20gentle%20color%20gradients&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="樱花动漫之家 - 在线免费观看动漫"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4">
        <div className="mb-4">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
            手机动漫门户
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          随时随地，畅享动漫世界
        </h1>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto leading-relaxed">
          樱花动漫之家为您精选海量动漫资源，热血、恋爱、奇幻、搞笑，各种类型一网打尽。专注移动端体验，让动漫触手可及。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/rexue"
            className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始探索
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-2.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-sm font-medium hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap border border-background-50/30"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">10,000+</div>
            <div className="text-xs text-background-50/70 mt-1">动漫资源</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">50万+</div>
            <div className="text-xs text-background-50/70 mt-1">日活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">99.7%</div>
            <div className="text-xs text-background-50/70 mt-1">好评率</div>
          </div>
        </div>
      </div>
    </section>
  );
}